export default function(unicodeText) {
  // calculates the length of unicode bytes for give string
  // sourced from https://github.com/substack/utf8-length
  return ~-encodeURI(unicodeText).split(/%..|./).length;
}
